export const CITATION_DOCUMENT_CATEGORY = 'Document category'
export const CITATION_UPLOAD_DATE = 'Upload date';
export const CITATION_DOWNLOAD_LINK = 'Download link';

export type CitationMetadata = { [key: string]: string };
